var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-section"},[_vm._t("default"),_vm._v(" "),_c('employee-slider',{staticClass:"hide-for-medium",attrs:{"parentImages":_vm.images,"items":_vm.items},on:{"shrinkFinished":_vm.triggerImageScroll}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageAnimationVisible),expression:"imageAnimationVisible"}],staticClass:"image-animation"},[_c('img',{attrs:{"id":"video","src":_vm.images[0].src,"alt":""}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1bc3a6e","hasScoped":true,"buble":{"transforms":{}}}!./src/components/HeroSection/HeroSection.html
// module id = null
// module chunks = 